import type { NavigationItem } from '../components/Navigation';
import { productManagementView } from '../components/product-management/productManagementRoutes';
import { productEntityId } from '../components/product-detail/navigation';

export function readLocationState(location: Pick<Location, 'pathname' | 'search'>) {
  const params = new URLSearchParams(location.search);
  const currentView: NavigationItem = (location.pathname === '/feedback' || location.pathname.startsWith('/feedback/') ? 'feedback' : null) ?? productManagementView(location.pathname)
    ?? (params.get('view') as NavigationItem | null)
    ?? 'dashboard';
  const conceptId = Number(params.get('conceptId'));
  const layout = params.get('layout');
  return {
    currentView,
    selectedProductId: productEntityId(location.pathname),
    editCampaignId: currentView === 'edit-campaign' ? params.get('campaignId') : null,
    campaignShowcaseId: currentView === 'campaign-showcase' ? params.get('campaignId') : null,
    campaignShowcaseLayout: (layout === 'storyboard' || layout === 'minimal' ? layout : 'spotlight') as 'spotlight' | 'storyboard' | 'minimal',
    selectedConceptId: (currentView === 'concept-detail' || currentView === 'edit-concept')
      && Number.isSafeInteger(conceptId) && conceptId > 0 ? conceptId : null,
  };
}

export function setConceptUrlState(params: URLSearchParams, view: NavigationItem, conceptId: number | null) {
  if ((view === 'concept-detail' || view === 'edit-concept') && conceptId !== null) {
    params.set('conceptId', String(conceptId));
  } else {
    params.delete('conceptId');
  }
}
